import { render, staticRenderFns } from "./Recintos.vue?vue&type=template&id=517d92a4&"
import script from "./Recintos.vue?vue&type=script&lang=js&"
export * from "./Recintos.vue?vue&type=script&lang=js&"
import style0 from "./Recintos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Recintos.vue"
export default component.exports